module.exports = __webpack_public_path__ + "img/21_75.3a60f301.png";